"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return _extendStatics(d, b);
  };
  return function (d, b) {
    _extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SlideIn = void 0;
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var react_dom_1 = __importDefault(require("react-dom"));
var classnames_1 = require("../util/classnames");
var events_1 = __importDefault(require("../util/dom-helpers/events"));
var dom_helpers_1 = require("../util/dom-helpers");
var create_chained_function_1 = __importDefault(require("../util/create-chained-function"));
var react_overlays_1 = require("../react-overlays");
var react_prop_types_1 = require("../react-prop-types");
var fade_1 = require("../fade");
var dialog_1 = require("./dialog");
var body_1 = require("./body");
var header_1 = require("./header");
var title_1 = require("./title");
var footer_1 = require("./footer");
var vdl_prefix_1 = require("../util/vdl-prefix");
var _1 = require("../util/_");
var SlideIn = /** @class */function (_super) {
  __extends(SlideIn, _super);
  //FIXME do we need constructor due to child context
  function SlideIn(props) {
    var _this = _super.call(this, props) || this;
    _this.state = {
      modalStyles: {}
    };
    _this.handleEntering = function () {
      // FIXME: This should work even when animation is disabled.
      events_1.default.on(window, 'resize', _this.handleWindowResize);
      setTimeout(function () {
        _this.updateStyle();
      });
    };
    _this.handleExited = function () {
      // FIXME: This should work even when animation is disabled.
      events_1.default.off(window, 'resize', _this.handleWindowResize);
    };
    _this.handleWindowResize = function () {
      _this.updateStyle();
    };
    _this.handleDialogClick = function (e) {
      if (e.target !== e.currentTarget) {
        return;
      }
      if (_this.props.onHide) {
        _this.props.onHide();
      }
    };
    _this.updateStyle = function () {
      if (!dom_helpers_1.inDOM) {
        return;
      }
      var dialogNode = _this._modal.getDialogElement();
      var dialogHeight = dialogNode ? dialogNode.scrollHeight : 0;
      var document = dom_helpers_1.ownerDocument(dialogNode);
      var bodyIsOverflowing = react_overlays_1.isOverflowing(react_dom_1.default.findDOMNode(_this.props.container || document.body));
      var modalIsOverflowing = dialogHeight > document.documentElement.clientHeight;
      _this.setState({
        style: {
          paddingRight: bodyIsOverflowing && !modalIsOverflowing ? dom_helpers_1.scrollbarSize() : undefined,
          paddingLeft: !bodyIsOverflowing && modalIsOverflowing ? dom_helpers_1.scrollbarSize() : undefined
        }
      });
    };
    return _this;
  }
  SlideIn.prototype.getChildContext = function () {
    return {
      '$vdl_onSlideInHide': this.props.onHide
    };
  };
  SlideIn.prototype.componentWillUnmount = function () {
    // Clean up the listener if we need to.
    this.handleExited();
  };
  SlideIn.prototype.render = function () {
    var _this = this;
    var _a = this.props,
      backdrop = _a.backdrop,
      show = _a.show,
      className = _a.className,
      style = _a.style,
      children = _a.children,
      dialogClassName = _a.dialogClassName,
      animation = _a.animation,
      transition = _a.transition,
      backdropClassName = _a.backdropClassName,
      onEntering = _a.onEntering,
      onExited = _a.onExited;
    var props = _1.omit(this.props, ['backdrop', 'show', 'className', 'style', 'children', 'dialogClassName', 'animation', 'transition', 'backdropClassName', 'onEntering', 'onExited']);
    var _b = _1.splitComponentProps(props, react_overlays_1.BaseModal),
      baseModalProps = _b[0],
      dialogProps = _b[1];
    var inClassName = show && !animation ? 'in' : undefined;
    // The display:none <span> is to work around a bizarre Chrome bug when using tabIndex -1 with the slide-in content
    // that causes unrelated inputs elsewhere on the page to not accept focus. Having some other node AFTER the
    // tabIndex -1 node makes the problem go away.
    return react_1.default.createElement(react_overlays_1.BaseModal, __assign({}, baseModalProps, {
      ref: function ref(c) {
        _this._modal = c;
        _this._wrapper = c ? c.getDialogElement() : undefined;
      },
      show: show,
      onEntering: create_chained_function_1.default(onEntering, this.handleEntering),
      onExited: create_chained_function_1.default(onExited, this.handleExited),
      backdrop: backdrop,
      backdropClassName: classnames_1.classNames(vdl_prefix_1.vdlPrefix('slide-in-backdrop'), inClassName, backdropClassName),
      transition: animation ? transition : undefined
    }), react_1.default.createElement(dialog_1.SlideInDialog, __assign({
      key: "slide-in"
    }, dialogProps, {
      style: Object.assign({}, this.state.style, style),
      className: classnames_1.classNames(className, inClassName),
      dialogClassName: dialogClassName,
      onClick: backdrop === true ? this.handleDialogClick : undefined
    }), children));
  };
  SlideIn.propTypes = Object.assign({}, react_overlays_1.BaseModal.propTypes, dialog_1.SlideInDialog.propTypes, {
    backdrop: prop_types_1.default.oneOf(['static', true, false]),
    keyboard: prop_types_1.default.bool,
    animation: prop_types_1.default.bool,
    dialogComponentClass: react_prop_types_1.elementType,
    autoFocus: prop_types_1.default.bool,
    enforceFocus: prop_types_1.default.bool,
    show: prop_types_1.default.bool,
    onHide: prop_types_1.default.func,
    onEnter: prop_types_1.default.func,
    onEntering: prop_types_1.default.func,
    onEntered: prop_types_1.default.func,
    onExit: prop_types_1.default.func,
    onExiting: prop_types_1.default.func,
    onExited: prop_types_1.default.func,
    showGraph: prop_types_1.default.bool,
    /**
     * @private
     */
    container: react_overlays_1.BaseModal.propTypes.container
  });
  SlideIn.childContextTypes = {
    '$vdl_onSlideInHide': prop_types_1.default.func
  };
  SlideIn.defaultProps = Object.assign({}, react_overlays_1.BaseModal.defaultProps, {
    animation: true,
    dialogComponentClass: dialog_1.SlideInDialog,
    dialogTransitionTimeout: 750,
    backdropTransitionTimeout: 150,
    transition: fade_1.Fade,
    backdropClassName: vdl_prefix_1.vdlPrefix('slide-in-backdrop'),
    containerClassName: vdl_prefix_1.vdlPrefix('modal-open')
  });
  SlideIn.Body = body_1.SlideInBody;
  SlideIn.Header = header_1.SlideInHeader;
  SlideIn.Title = title_1.SlideInTitle;
  SlideIn.Footer = footer_1.SlideInFooter;
  SlideIn.Dialog = dialog_1.SlideInDialog;
  return SlideIn;
}(react_1.default.Component);
exports.SlideIn = SlideIn;